import React from 'react';
import { VStack, Box, Skeleton, SkeletonText } from '@chakra-ui/react';

const SchedulesSkeleton = () => {
  return (
    <VStack spacing={4} align="stretch">
      {Array.from({ length: 5 }).map((_, i) => (
        <Box key={i} p={3} borderWidth="1px" borderRadius="md">
          <Skeleton height="14px" width="140px" mb={2} />
          <SkeletonText noOfLines={2} spacing="2" skeletonHeight="10px" />
        </Box>
      ))}
    </VStack>
  );
};

export default SchedulesSkeleton;
